import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

const ScienceLab = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
        AOS.init({ duration: 1000 });
    }, []);
    return (
        <div className="container mx-auto px-6 py-12">
            {/* Heading */}
            <h1 className="text-3xl font-bold text-center mb-6">SCIENCE LAB</h1>


            <div className="w-full " data-aos="fade-up">
                <p className="text-lg  text-gray-700 leading-relaxed">
                    The Science Lab is a place where students explore, experiment, and innovate. Equipped with modern instruments and facilities, our lab provides hands-on learning experiences that enhance scientific understanding. Students engage in exciting experiments, fostering curiosity and a deeper appreciation for science. We ensure a safe and interactive environment where young minds can develop critical thinking and problem-solving skills.
                </p>

            </div>


            {/* Image Grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4 mt-8" data-aos="fade-up">
                <img src="https://img.freepik.com/free-vector/frame-with-children-lab_1308-31235.jpg?ga=GA1.1.736731524.1738591350&semt=ais_hybrid" alt="Smart Classroom 1" className="w-full h-48 object-cover rounded-lg shadow-md" />
                <img src="https://img.freepik.com/free-vector/frame-with-children-lab_1308-31235.jpg?ga=GA1.1.736731524.1738591350&semt=ais_hybrid" alt="Smart Classroom 2" className="w-full h-48 object-cover rounded-lg shadow-md" />
                <img src="https://img.freepik.com/free-vector/frame-with-children-lab_1308-31235.jpg?ga=GA1.1.736731524.1738591350&semt=ais_hybrid" alt="Smart Classroom 3" className="w-full h-48 object-cover rounded-lg shadow-md" />
                <img src="https://img.freepik.com/free-vector/frame-with-children-lab_1308-31235.jpg?ga=GA1.1.736731524.1738591350&semt=ais_hybrid" alt="Smart Classroom 4" className="w-full h-48 object-cover rounded-lg shadow-md" />
            </div>
        </div>
    );
}

export default ScienceLab;





